import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

interface SignatureStatusIndicatorProps {
    isSigned: boolean;
}

export const SignatureStatusIndicator: React.FC<SignatureStatusIndicatorProps> = ({ isSigned }) => {
    return isSigned ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'success.main', mt: 1 }}>
            <CheckCircleIcon sx={{ fontSize: 24 }} />
            <Typography variant="body2" sx={{ color: 'success.main', fontWeight: 500 }}>
                Signed
            </Typography>
        </Box>
    ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'error.main', mt: 1 }}>
            <CancelIcon sx={{ fontSize: 24 }} />
            <Typography variant="body2" sx={{ color: 'error.main', fontWeight: 500 }}>
                Pending
            </Typography>
        </Box>
    );
};
